// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-card {\n    border: 1px solid #CCC !important;\n    padding: 0.75rem 0.5rem;\n    margin-bottom: 1.5rem;\n    background: transparent;\n    border-radius: 0 !important;\n    box-shadow: 0 2px 0.25rem 0.1px rgba(176, 176, 176, 0.25);\n}", ""]);
// Exports
module.exports = exports;
